import axios from 'axios'
import mock from '../mock'

import { BackendUrl } from '@src/BackendUrl'

// ** Utils
import { paginateArray } from '../utils'

const data = {
  users: [
    {
      id: 1,
      billing: 'Manual - Credit Card',
      fullName: 'Galen Slixby',
      company: 'Yotz PVT LTD',
      role: 'editor',
      username: 'gslixby0',
      country: 'El Salvador',
      contact: '(479) 232-9151',
      email: 'gslixby0@abc.net.au',
      currentPlan: 'enterprise',
      status: 'inactive',
      avatar: ''
    },
    {
      id: 2,
      billing: 'Manual - Paypal',
      fullName: 'Halsey Redmore',
      company: 'Skinder PVT LTD',
      role: 'author',
      username: 'hredmore1',
      country: 'Albania',
      contact: '(472) 607-9137',
      email: 'hredmore1@imgur.com',
      currentPlan: 'team',
      status: 'pending',
      avatar: require('@src/assets/images/avatars/10.png').default
    },
    {
      id: 3,
      billing: 'Auto Debit',
      fullName: 'Marjory Sicely',
      company: 'Oozz PVT LTD',
      role: 'maintainer',
      username: 'msicely2',
      country: 'Russia',
      contact: '(321) 264-4599',
      email: 'msicely2@who.int',
      currentPlan: 'enterprise',
      status: 'active',
      avatar: require('@src/assets/images/avatars/1.png').default
    },
    {
      id: 4,
      billing: 'Manual - Credit Card',
      fullName: 'Cyrill Risby',
      company: 'Oozz PVT LTD',
      role: 'maintainer',
      username: 'crisby3',
      country: 'China',
      contact: '(923) 690-6806',
      email: 'crisby3@wordpress.com',
      currentPlan: 'team',
      status: 'inactive',
      avatar: require('@src/assets/images/avatars/9.png').default
    },
    {
      id: 5,
      billing: 'Auto Debit',
      fullName: 'Maggy Hurran',
      company: 'Aimbo PVT LTD',
      role: 'subscriber',
      username: 'mhurran4',
      country: 'Pakistan',
      contact: '(669) 914-1078',
      email: 'mhurran4@yahoo.co.jp',
      currentPlan: 'enterprise',
      status: 'pending',
      avatar: require('@src/assets/images/avatars/10.png').default
    }
  ]
}

// GET ALL DATA
//mock.onGet('/api/users/list/all-data').reply(200, data.users)

// mock.onGet('/api/users/list/all-data')//.reply(200, 'hello')
//     .then(async function () {
//       const response = await axios.get('http://localhost:4000/api/users')
//       alert(response)
//       return response
//     })//.reply(200, response)
    

// mock.onGet('/api/users/list/all-data', async function() {
//   const sqlData = await axios.get('http://localhost:4000/api/users')

//   users = sqlData.data
//   console.log("ti einai", users)
//   return [200, { users }]
// })

// mock.onGet('/api/users/list/all-data').reply(async () => {
//   const sqlData = await axios.get('http://localhost:4000/api/users')

//   //users = sqlData.data
//   //console.log(test)
//   console.log("ti einai", sqlData)
//   return sqlData
// })


//   const sqlData = await axios.get('http://localhost:4000/api/users')

//   //users = sqlData.data
//   console.log("ti einai", sqlData)

//   //return sqlData
// })

// export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  
//   const response = await axios.get('/api/users/list/all-data')

//   //**-* Panos elegxos an pernaei apo edw
//   console.log("Pernaei apo edw", response)
//   return response.data
// })


// POST: Add new user
mock.onPost('/apps/users/add-user').reply(config => {
  // Get event from post data
  const user = JSON.parse(config.data)
  const highestValue = data.users.reduce((a, b) => (a.id > b.id ? a : b)).id

  user.id = highestValue + 1

  data.users.push(user)

  alert(json.stringify(user))

  return [201, { user }]
})

// GET Updated DATA
mock.onGet('/api/users/list/data').reply(async config => {


  //**-* PANOS GET USER DATA FROM SQL DATABASE

  const sqlData = await axios.get(`${BackendUrl()}/api/users`)
  //const users = sqlData.data
  console.log("data from backend", sqlData)

  const DATATEST = {
    users: [
      {
      id: 15,
      billing: 'Auto Debit',
      fullName: 'Panagiotis Mavroukas Karfoto',
      company: 'Dirigo IKE',
      role: 'admin',
      username: 'p.mavroukas@dirigo.gr',
      country: 'Greece',
      contact: 'no',
      email: 'p.mavroukas@dirigo.gr',
      currentPlan: 'company',
      status: 'active',
      avatar: ''
      }
    ]
  }
  console.log("Karfwtos user sti React gia dokimi", DATATEST)
  

  const {
    q = '',
    page = 1,
    role = null,
    perPage = 10,
    sort = 'asc',
    ///status = null,
    //currentPlan = null,
    sortColumn = 'fullName'
  } = config

  /* eslint-disable  */
  const queryLowered = q.toLowerCase()

  //const dataAsc = data.users.sort((a, b) => (a[sortColumn] < b[sortColumn] ? -1 : 1))      //ORIGINAL
  //const dataAsc = DATATEST.users.sort((a, b) => (a[sortColumn] < b[sortColumn] ? -1 : 1))  //TEST LOCAL CODE
  const dataAsc = sqlData.data.users.sort((a, b) => (a[sortColumn] < b[sortColumn] ? -1 : 1))    //TEST SQL DATABASE

  //console.log("dataAsc", dataAsc)

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  //console.log('dataToFilter', dataToFilter)

  // const filteredData = dataToFilter.filter(
  //   user =>
  //     (user.email.toLowerCase().includes(queryLowered) ||
  //       user.fullName.toLowerCase().includes(queryLowered) ||
  //       user.billing.toLowerCase().includes(queryLowered)
  //     ) &&
  //     user.role === (role || user.role) &&
  //     user.currentPlan === (currentPlan || user.currentPlan) &&
  //     user.status === (status || user.status)
  // )


  const filteredDataNEW = dataToFilter.filter(
    user =>
      (user.email.toLowerCase().includes(queryLowered) ||
        user.fullName.toLowerCase().includes(queryLowered)
      ) &&
      user.role === (role || user.role)
  )
  /* eslint-enable  */

  console.log("filtered data new", filteredDataNEW)
  return [
    200,
    {
      total: filteredDataNEW.length,
      users: paginateArray(filteredDataNEW, perPage, page)
    }
  ]
})

// GET USER
mock.onGet('/api/users/user').reply(config => {
  const { id } = config
  const user = data.users.find(i => i.id === id)
  return [200, { user }]
})

// DELETE: Deletes User
mock.onDelete('/apps/users/delete').reply(config => {
  // Get user id from URL
  let userId = config.id

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.users.findIndex(t => t.id === userId)
  data.users.splice(userIndex, 1)

  return [200]
})
